import axios from "@/request";
import qs from "qs";

export default {
  async overview(params: any) {
    return axios.get("stadium/overview", { params });
  },
  async stadiumstatus(params: any) {
    return axios.post("stadium/stadiumstatus", qs.stringify(params));
  },
  async mediastatus(params: any) {
    return axios.post("stadium/mediastatus", qs.stringify(params));
  },
  async sendCommand(params: any) {
    return axios.post("local/send-command", qs.stringify(params));
  },
  async setControlKeep(params: any) {
    return axios.post("local/gate-keep-open", qs.stringify(params));
  },
  async setControlOpen(params: any) {
    return axios.post("local/gate-open", qs.stringify(params));
  },
  async setControlClose(params: any) {
    return axios.post("local/gate-close", qs.stringify(params));
  },
  async getControlPeriod(params: any) {
    return axios.get("local/get-gate-keep-open-period", { params });
  },
  async setControlPeriod(params: any) {
    return axios.post("local/gate-keep-open-period", qs.stringify(params));
  },
  async updateWithFields(params: any) {
    return axios.post("stadium/update-with-fields", qs.stringify(params));
  },
  async uploadFile(params: any) {
    return axios.post("cos/upload", params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  async getStatistics(params: any) {
    return axios.get("stadium/statistics", { params });
  },
  async getOnlineStatusLogs(params: any) {
    return axios.get("stadium/onlinestatuslogs", { params });
  },
  // 设备配置下发
  async deliverStadiumEquip(params: any) {
    return axios.post("local/notice-stadium-update", qs.stringify(params));
  },
  async refreshEquipStatus(params: any) {
    return axios.post("local/refresh-equip-status", qs.stringify(params));
  },
  async orderOnline(params: any) {
    return axios.post("stadium/order-online", qs.stringify(params));
  },
  async orderOffline(params: any) {
    return axios.post("stadium/order-offline", qs.stringify(params));
  },
  async aiOnline(params: any) {
    return axios.post("stadium/ai-online", qs.stringify(params));
  },
  async aiOffline(params: any) {
    return axios.post("stadium/ai-offline", qs.stringify(params));
  },
  async phoneOnline(params: any) {
    return axios.post("stadium/phone-online", qs.stringify(params));
  },
  async phoneOffline(params: any) {
    return axios.post("stadium/phone-offline", qs.stringify(params));
  },
  // 获取单个场馆信息
  async getStadium(params: any) {
    return axios.get("stadium/info", { params });
  },
  // 获取新场馆申请记录
  async getStadiumApplications(params: any) {
    return axios.get("stadium/list-for-enter-apply", { params });
  },
  // 获取场馆列表
  async getStadiums(params: any) {
    return axios.get("stadium/list", { params });
  },
  // 保存场馆信息
  async saveStadium2(params: any) {
    return axios.post("stadium/update?type=2", params, {
      headers: { "Content-Type": "application/json" }
    });
  },
  async getStadiumMainEquipments(params: any) {
    return axios.get("stadium-equipment-master/list", { params });
  },
  async saveStadiumMainEquipment(params: any) {
    return axios.post("stadium-equipment-master/save", params, {
      headers: { "Content-Type": "application/json" }
    });
  },
  async initStadiumEquipment(params: any) {
    return axios.post("stadium-equipment-master/reinitialize", qs.stringify(params));
  },
  async getStadiumSwitchEquipments(params: any) {
    return axios.get("stadium-equipment-switch/list", { params });
  },
  async getStadiumSubEquipments(params: any) {
    return axios.get("stadium-equipment-sub/list", { params });
  },
  async saveStadiumSubEquipment(params: any) {
    return axios.post("stadium-equipment-sub/save", params, {
      headers: { "Content-Type": "application/json" }
    });
  },
  async saveStadiumEquipments(params: any) {
    return axios.post("stadium-equipment-master/save", qs.stringify(params));
  },
  async saveGrounds(params: any) {
    return axios.post("stadium-ground/save", qs.stringify(params));
  },
  async getStadiumGrounds(params: any) {
    return axios.get("stadium-ground/list", { params });
  },
  async addGround(params: any) {
    return axios.post("stadium-ground/add", qs.stringify(params));
  },
  async editGround(params: any) {
    return axios.post("stadium-ground/edit", qs.stringify(params));
  },
  async deleteGround(params: any) {
    return axios.post("stadium-ground/delete", qs.stringify(params));
  },
  async getGround(params: any) {
    return axios.get("stadium-ground/detail", { params });
  },
  async checkOrdered(params: any) {
    return axios.get("stadium-ground/check-ordered", { params });
  },
  async closeList(params: any) {
    return axios.get("stadium-ground/close-list", { params });
  },
  async closeReopen(params: any) {
    return axios.post("stadium-ground/close-reopen", qs.stringify(params));
  },
  async orderedGround(params: any) {
    return axios.post("stadium-ground/ordered", qs.stringify(params));
  },
  async orderedGroundDelete(params: any) {
    return axios.post("stadium-ground/ordered-delete", qs.stringify(params));
  },
  async orderedGroundDeleteById(params: any) {
    return axios.post("stadium-ground/ordered-delete-by-id", qs.stringify(params));
  },
  async groundEvents(params: any) {
    return axios.get("stadium-ground/events", { params });
  },
  async groundEventsCount(params: any) {
    return axios.get("stadium-ground/events-count", { params });
  },
  async getStadiumGroundTimeCost(params: any) {
    return axios.get("stadium-ground-time-cost/detail", { params });
  },
  async editStadiumGroundTimeCost(params: any) {
    return axios.post("stadium-ground-time-cost", qs.stringify(params));
  },
  async deleteStadiumGroundTimeCost(params: any) {
    return axios.post("stadium-ground-time-cost/delete", qs.stringify(params));
  },
  async getStadiumPriceSetting(params: any) {
    return axios.get("stadium-price-setting/list", { params });
  },
  async saveStadiumPriceSetting(params: any) {
    return axios.post("stadium-price-setting/save", params, {
      headers: { "Content-Type": "application/json" }
    });
  },
  async addStadiumPrice(params: any) {
    return axios.post("stadium-price-setting/add", qs.stringify(params));
  },
  async editStadiumPrice(params: any) {
    return axios.post("stadium-price-setting/edit", qs.stringify(params));
  },
  async resetStadiumPrice(params: any) {
    return axios.post("stadium-price-setting/reset", qs.stringify(params));
  },
  async businessTime(params: any) {
    return axios.get("stadium-price-setting/business-time", { params });
  },
  async getTags(params: any) {
    return axios.get("tag/list", { params });
  },
  // 场馆配套设施
  async getStadiumTags(params: any) {
    return axios.get("stadium-tag/detail", { params });
  },
  // 保存场馆配套设施
  async saveStadiumTags(params: any) {
    return axios.post("stadium-tag/update", qs.stringify(params));
  },
  async saveStadiumDetail(params: any) {
    return axios.post("stadium-detail/update", qs.stringify(params));
  },
  async aiOnlineNotice(params: any) {
    return axios.post("stadium/ai-online-notice", qs.stringify(params));
  },
  async orderOnlineNotice(params: any) {
    return axios.post("stadium/order-online-notice", qs.stringify(params));
  },
  async updateAiSignTime(params: any) {
    return axios.post("stadium-detail/update-ai-sign-time", qs.stringify(params));
  },
  async updateAiOnLineTime(params: any) {
    return axios.post("stadium/update-ai-on-line-time", qs.stringify(params));
  },
  async getEquipCameras(params: any) {
    return axios.get("equipment-camera/list-by-stadium", { params });
  },
  async addEquipCamera(params: any) {
    return axios.post("equipment-camera/add", qs.stringify(params));
  },
  async getEquipCamera(params: any) {
    return axios.get("equipment-camera/detail", { params });
  },
  async editEquipCamera(params: any) {
    return axios.post("equipment-camera/edit", qs.stringify(params));
  },
  async deleteEquipCamera(params: any) {
    return axios.post("equipment-camera/delete", qs.stringify(params));
  },
  async getQrcode(params: any) {
    return axios.get("stadium-detail/qrcode", { params });
  },
  async addBalance(params: any) {
    return axios.post("stadium-balance/add", qs.stringify(params));
  },
  async getBalances(params: any) {
    return axios.get("stadium-balance/list", { params });
  },
  async rechargeBalance(params: any) {
    return axios.post("stadium-balance/recharge", qs.stringify(params));
  },
  async deductBalance(params: any) {
    return axios.post("stadium-balance/cost", qs.stringify(params));
  },
  async applyInfo(params: any) {
    return axios.get("stadium-enter-apply/info", { params });
  },
  async applyInfo1(params: any) {
    return axios.get("stadium-enter-apply/online-setting", { params });
  },
  async bookingInfo(params: any) {
    return axios.get("stadium-enter-apply/booking-info", { params });
  },
  async applyUpdate(params: any) {
    return axios.post("stadium-enter-apply/update-with-fields", qs.stringify(params));
  },
  async applyComplete(params: any) {
    return axios.post("stadium-enter-apply/audit", qs.stringify(params));
  },
  async applyHandle(params: any) {
    return axios.post("stadium-enter-apply/handle", qs.stringify(params));
  },
  async applyRecord(params: any) {
    return axios.get("stadium-enter-apply/record", { params });
  },
  async applyAuditHistory(params: any) {
    return axios.get("stadium-enter-apply/audit-history", { params });
  },
  async applyUserAction(params: any) {
    return axios.get("user-action/newlist", { params });
  },
  async add(params: any) {
    return axios.post("stadium/create", qs.stringify(params));
  },
  async restartSubEquip(params: any) {
    return axios.post("local/sub-reboot-by-id", qs.stringify(params));
  },
  async toggleSubEquip(params: any) {
    return axios.post("local/sub-ctl-by-id", qs.stringify(params));
  },
  async toggleMainEquip(params: any) {
    return axios.post("local/up-down-ctl", qs.stringify(params));
  },
  async toggleVideoEquip(params: any) {
    return axios.post("local/video-lifter-ctl", qs.stringify(params));
  },
  async settlementItems(params: any) {
    return axios.get("settlement-setting/items", { params });
  },
  async settlementAddItem(params: any) {
    return axios.post("settlement-setting/additem", qs.stringify(params));
  },
  async settlementEditItem(params: any) {
    return axios.post("settlement-setting/edititem", qs.stringify(params));
  },
  async settlementItem(params: any) {
    return axios.get("settlement-setting/itemdetail", { params });
  },
  async settlementSetting(params: any) {
    return axios.get("settlement-setting/list", { params });
  },
  async settlementSettingSave(params: any) {
    return axios.post("settlement-setting/save", qs.stringify(params));
  },
  async settlementSettingSaveDate(params: any) {
    return axios.post("settlement-setting/update-item-date", qs.stringify(params));
  },
  async settlementSettingSaveName(params: any) {
    return axios.post("settlement-setting/update-item-name", qs.stringify(params));
  },
  async settlementItemsDetailList(params: any) {
    return axios.get("settlement-setting/items-detail-list", { params });
  },
  async settlementItemsDetailAdd(params: any) {
    return axios.post("settlement-setting/items-detail-add", qs.stringify(params));
  },
  async settlementItemsDetailEdit(params: any) {
    return axios.post("settlement-setting/items-detail-edit", qs.stringify(params));
  },
  async settlementItemsDetailDetail(params: any) {
    return axios.get("settlement-setting/items-detail-detail", { params });
  },
  async settlementItemsDetailDelete(params: any) {
    return axios.post("settlement-setting/items-detail-delete", qs.stringify(params));
  },
  async onlineProgress(params: any) {
    return axios.get("onlineprogress/list", { params });
  },
  async allowNotUpgrade(params: any) {
    return axios.post("stadium-enter-apply/abandon-upgrade", qs.stringify(params));
  },
  async allowUpgrade(params: any) {
    return axios.post("onlineprogress/allow-upgrade", qs.stringify(params));
  },
  async allowUpgradeStatus(params: any) {
    return axios.get("onlineprogress/allow-upgrade-status", { params });
  },
  async regenerate(params: any) {
    return axios.post("onlineprogress/re-generate", qs.stringify(params));
  },
  async manageRecordList(params: any) {
    return axios.get("stadium-manage-record/list", { params });
  },
  async manageRecordDetail(params: any) {
    return axios.get("stadium-manage-record/detail", { params });
  },
  async claims(params: any) {
    return axios.get("stadium-claim/list", { params });
  },
  async sendinvitecode(params: any) {
    return axios.post("stadium/sendinvitecode", qs.stringify(params));
  },
  async rollscreenimage(params: any) {
    return axios.get("stadium-detail/rollscreenimage", { params });
  },
  async reportpathai(params: any) {
    return axios.get("stadium-detail/reportpathai", { params });
  },
  async reportpathonline(params: any) {
    return axios.get("stadium-detail/reportpathonline", { params });
  },
  async reportdownqrcode(params: any) {
    return axios.get("stadium-detail/reportdownqrcode", { params });
  },
  async reportprintqrcode(params: any) {
    return axios.get("stadiumm-detail/reportprintqrcode", { params });
  },
  async downqrcode(params: any) {
    return axios.get("stadium-detail/downqrcode", { params });
  },
  async miniprogramqrcode(params: any) {
    return axios.get("stadium-detail/miniprogram_qrcode", { params });
  },
  async getGroundRobots(params: any) {
    return axios.get("stadium-ground-robots/list", { params });
  },
  async changeGroundRobotStatus(params: any) {
    return axios.post("stadium-ground-robots/status", qs.stringify(params));
  },
  async settingDetail(params: any) {
    return axios.get("stadium-setting/detail", { params });
  },
  async settingChange(params: any) {
    return axios.post("stadium-setting/change", qs.stringify(params));
  },
  async unbindweixin(params: any) {
    return axios.post("stadium-setting/unbindweixin", qs.stringify(params));
  },
  async discovery(params: any) {
    return axios.get("stadium-report/list", { params });
  },
  async discoverydetail(params: any) {
    return axios.get("stadium-report/detail", { params });
  },
  async discoveryhandle(params: any) {
    return axios.post("stadium-report/handle", qs.stringify(params));
  },
  async vips(params: any) {
    return axios.get("stadium/vips", { params });
  },
  async addvip(params: any) {
    return axios.post("stadium/addvip", qs.stringify(params));
  },
  async getvipsetting(params: any) {
    return axios.get("stadium/getvipsetting", { params });
  },
  async savevipsetting(params: any) {
    return axios.post("stadium/savevipsetting", qs.stringify(params));
  },
  async changeVipSettingStatus(params: any) {
    return axios.post("stadium/change-vip-setting-status", qs.stringify(params));
  },
  async vipSettingAdd(params: any) {
    return axios.post("stadium/vip-setting-add", qs.stringify(params));
  },
  async vipSettingEdit(params: any) {
    return axios.post("stadium/vip-setting-edit", qs.stringify(params));
  },
  async vipSettingDelete(params: any) {
    return axios.post("stadium/vip-setting-delete", qs.stringify(params));
  },
  async vipSettingOn(params: any) {
    return axios.post("stadium/vip-setting-on", qs.stringify(params));
  },
  async vipSettingOff(params: any) {
    return axios.post("stadium/vip-setting-off", qs.stringify(params));
  },
  async users(params: any) {
    return axios.get("stadium/users", { params });
  },
  async deleteUser(params: any) {
    return axios.post("stadium/deleteuser", qs.stringify(params));
  },
  async accounts(params: any) {
    return axios.get("stadium/accounts", { params });
  },
  async addAccount(params: any) {
    return axios.post("stadium/add-account", qs.stringify(params));
  },
  async editAccount(params: any) {
    return axios.post("stadium/edit-account", qs.stringify(params));
  },
  async getAccount(params: any) {
    return axios.get("stadium/get-account", { params });
  },
  async deleteAccount(params: any) {
    return axios.post("stadium/delete-account", qs.stringify(params));
  },
  async changeAccountStatus(params: any) {
    return axios.post("stadium/change-account-status", qs.stringify(params));
  },
  async permissions(params: any) {
    return axios.get("stadium/permissions", { params });
  },
  async roles(params: any) {
    return axios.get("stadium/roles", { params });
  },
  async similar(params: any) {
    return axios.get("stadium/similar", { params });
  },
  async notes(params: any) {
    return axios.get("stadium/notes", { params });
  },
  async addnote(params: any) {
    return axios.post("stadium/addnote", qs.stringify(params));
  },
  async addStadium(params: any) {
    return axios.post("stadium/add", qs.stringify(params));
  },
  async addCertificate(params: any) {
    return axios.post("stadium/add-certificate", qs.stringify(params));
  },
  async addAgreement(params: any) {
    return axios.post("stadium/add-agreement", qs.stringify(params));
  },
  async getClosuretime(params: any) {
    return axios.get("closuretime/list", { params });
  },
  async saveClosuretime(params: any) {
    return axios.post("closuretime/save", qs.stringify(params));
  },
  async getMedia(params: any) {
    return axios.get("stadium/getmedia", { params });
  },
  async saveMedia(params: any) {
    return axios.post("stadium/savemedia", qs.stringify(params));
  },
  async getBank(params: any) {
    return axios.get("stadium-bank/detail", { params });
  },
  async saveBank(params: any) {
    return axios.post("stadium-bank/save", qs.stringify(params));
  },
  async getReport(params: any) {
    return axios.get("stadium-detail/get-report", { params });
  },
  async saveReport(params: any) {
    return axios.post("stadium-detail/save-report", qs.stringify(params));
  },
  async saveSaler(params: any) {
    return axios.post("stadium-detail/save-saler", qs.stringify(params));
  },
  async getExpense(params: any) {
    return axios.get("stadium-detail/get-expense", { params });
  },
  async saveExpense(params: any) {
    return axios.post("stadium-detail/save-expense", qs.stringify(params));
  },
  async getBlocks(params: any) {
    return axios.get("stadium-block/list", { params });
  },
  async addBlock(params: any) {
    return axios.post("stadium-block/add", qs.stringify(params));
  },
  async editBlock(params: any) {
    return axios.post("stadium-block/edit", qs.stringify(params));
  },
  async getBlock(params: any) {
    return axios.get("stadium-block/detail", { params });
  },
  async deleteBlock(params: any) {
    return axios.post("stadium-block/delete", qs.stringify(params));
  },
  async authuserlist(params: any) {
    return axios.get("stadium-auth-user/list", { params });
  },
  async addauthuser(params: any) {
    return axios.post("stadium-auth-user/add", qs.stringify(params));
  },
  async editauthuser(params: any) {
    return axios.post("stadium-auth-user/edit", qs.stringify(params));
  },
  async getauthuser(params: any) {
    return axios.get("stadium-auth-user/detail", { params });
  },
  async deleteauthuser(params: any) {
    return axios.post("stadium-auth-user/delete", qs.stringify(params));
  },
  async customaudioplay(params: any) {
    return axios.get("custom_audio_play/list", { params });
  },
  async addcustomaudioplay(params: any) {
    return axios.post("custom_audio_play/add", qs.stringify(params));
  },
  async againcustomaudioplay(params: any) {
    return axios.post("custom_audio_play/again", qs.stringify(params));
  },
  async addrank(params: any) {
    return axios.post("stadium/add-rank", qs.stringify(params));
  },
  async waitSettlement(params: any) {
    return axios.get("stadium/wait-settlement", { params });
  },
  async copyDemoData(params: any) {
    return axios.post("stadium/copy-demo-data", qs.stringify(params));
  },
  async deleteDemoData(params: any) {
    return axios.post("stadium/delete-demo-data", qs.stringify(params));
  },
  async manager(params: any) {
    return axios.get("stadium/manager", { params });
  },
  async managerlogout(params: any) {
    return axios.get("stadium-manager/logout", { params });
  },
  async products(params: any) {
    return axios.get("stadium-product/list", { params });
  },
  async addproduct(params: any) {
    return axios.post("stadium-product/add", qs.stringify(params));
  },
  async editproduct(params: any) {
    return axios.post("stadium-product/edit", qs.stringify(params));
  },
  async getproduct(params: any) {
    return axios.get("stadium-product/detail", { params });
  },
  async deleteproduct(params: any) {
    return axios.post("stadium-product/delete", qs.stringify(params));
  },
  async priceextend(params: any) {
    return axios.get("stadium-price-extend/list", { params });
  },
  async addpriceextend(params: any) {
    return axios.post("stadium-price-extend/add", qs.stringify(params));
  },
  async editpriceextend(params: any) {
    return axios.post("stadium-price-extend/edit", qs.stringify(params));
  },
  async getpriceextend(params: any) {
    return axios.get("stadium-price-extend/detail", { params });
  },
  async deletepriceextend(params: any) {
    return axios.post("stadium-price-extend/delete", qs.stringify(params));
  },
  async timeSaleSetting(params: any) {
    return axios.get("stadium-time-sale-setting/list", { params });
  },
  async timeSaleSettingAdd(params: any) {
    return axios.post("stadium-time-sale-setting/add", qs.stringify(params));
  },
  async timeSaleSettingEdit(params: any) {
    return axios.post("stadium-time-sale-setting/edit", qs.stringify(params));
  },
  async timeSaleSettingDetail(params: any) {
    return axios.get("stadium-time-sale-setting/detail", { params });
  },
  async timeSaleSettingDelete(params: any) {
    return axios.post("stadium-time-sale-setting/delete", qs.stringify(params));
  },
  async bindAuthUser(params: any) {
    return axios.post("stadium/bind-auth-user", qs.stringify(params));
  },
  async unbindAuthUser(params: any) {
    return axios.post("stadium/unbind-auth-user", qs.stringify(params));
  },
  // 参数设置获取列表
  async getParamsSetting(params: any) {
    return axios.get("stadium-setting/list-properties", { params });
  },
  // 提交参数设置
  async postParamsSetting(params: any) {
    return axios.post("stadium-setting/batch-change", qs.stringify(params));
  },
  async setIsInternal(params: any) {
    return axios.post("stadium/set-is-internal", qs.stringify(params));
  },
  async resignApplyAgreement(params: any) {
    return axios.post("stadium/resign-apply-agreement", qs.stringify(params));
  },
  async resignAIAgreement(params: any) {
    return axios.post("stadium/resign-ai-agreement", qs.stringify(params));
  },
  async activeOnlineReadTime(params: any) {
    return axios.post("stadium/active-online-read-time", qs.stringify(params));
  },
  async wechatStadiumSetting(params: any) {
    return axios.post("stadium/wechat-stadium-setting", qs.stringify(params));
  },
  async internalStadiumSetting(params: any) {
    return axios.post("stadium/internal-stadium-setting", qs.stringify(params));
  },
  async changeVersion(params: any) {
    return axios.post("stadium/change-version", qs.stringify(params));
  },
  async reduceToPhoneOnline(params: any) {
    return axios.post("stadium/reduce-to-phone-online", qs.stringify(params));
  },
  async todayBuy(params: any) {
    return axios.get("stadium-statistics/today-buy", { params });
  },
  async todayPlay(params: any) {
    return axios.get("stadium-statistics/today-play", { params });
  },
  async costAB(params: any) {
    return axios.get("stadium-statistics/cost-ab", { params });
  },
  async billAB(params: any) {
    return axios.get("stadium-statistics/bill-ab", { params });
  },
  async dailySituationInfo(params: any) {
    return axios.get("stadium-ground/daily-situation-info", { params });
  },
  async researchReport(params: any) {
    return axios.get("research-report/list", { params });
  },
  async researchReportSave(params: any) {
    return axios.post("research-report/save", qs.stringify(params));
  },
  async researchReportDetail(params: any) {
    return axios.get("research-report/detail", { params });
  },
  async researchReportChangeField(params: any) {
    return axios.post("research-report/change-field-value", qs.stringify(params));
  },
  async nearStadium(params: any) {
    return axios.get("research-report/near-stadium", { params });
  },
  async userPlayer(params: any) {
    return axios.get("stadium/user-player", { params });
  },
  async getTaisamSetting(params: any) {
    return axios.get("stadium/get-taisam-setting", { params });
  },
  async saveTaisamSetting(params: any) {
    return axios.post("stadium/save-taisam-setting", qs.stringify(params));
  },
  async taisamAnaly(params: any) {
    return axios.get("stadium/taisam-analy", { params });
  },
  async countBill(params: any) {
    return axios.get("stadium/count-bill", { params });
  },
  async cloneStadium(params: any) {
    console.log(params)
    return axios.get("stadium/clone", { params });
  }
};
